import { render, staticRenderFns } from "./CopyrightAmendmentTab.vue?vue&type=template&id=79b6d1d6&scoped=true&"
import script from "./CopyrightAmendmentTab.vue?vue&type=script&lang=js&"
export * from "./CopyrightAmendmentTab.vue?vue&type=script&lang=js&"
import style0 from "./CopyrightAmendmentTab.vue?vue&type=style&index=0&id=79b6d1d6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79b6d1d6",
  null
  
)

export default component.exports